module.exports = __webpack_public_path__ + "img/img35.90881ad9.svg";